declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

const MEASUREMENT_ID = 'G-CHDGQ4NF20'
const SCRIPT_ID = 'google-analytics-script'

/** Loads the Google tag exactly once without requiring access to index.html. */
export function initializeAnalytics() {
  if (typeof window === 'undefined' || document.getElementById(SCRIPT_ID)) return

  window.dataLayer = window.dataLayer ?? []
  window.gtag = (...args: unknown[]) => {
    window.dataLayer?.push(args)
  }
  window.gtag('js', new Date())
  window.gtag('config', MEASUREMENT_ID, { send_page_view: false })

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
  document.head.appendChild(script)
}

/** Records SPA route changes as GA4 page views. */
export function trackPageView(path: string) {
  window.gtag?.('event', 'page_view', {
    page_location: window.location.href,
    page_path: path,
    send_to: MEASUREMENT_ID,
  })
}
